import React from "react";
import { PageHeader } from "./Formats";

export default function Cookie() {
  return (
    <div data-testid="cookie-page">
      <PageHeader eyebrow="Legal" title="Cookie Policy" subtitle="Informativa estesa sull'utilizzo dei cookie ai sensi del provvedimento del Garante Privacy del 10 giugno 2021." />
      <section className="bg-[#0a0a0a] pb-32">
        <div className="container-x max-w-3xl text-[color:var(--txt-secondary)] leading-relaxed space-y-6">
          <h3 className="text-white font-display text-2xl">1. Cosa sono i cookie</h3>
          <p>
            I cookie sono piccoli file di testo memorizzati dal browser durante la navigazione.
            Permettono al sito di funzionare correttamente, di ricordare alcune preferenze e — se autorizzati — di raccogliere
            informazioni statistiche sull'utilizzo del sito.
          </p>

          <h3 className="text-white font-display text-2xl">2. Cookie utilizzati da Scudieri Group</h3>
          <p>Il sito utilizza esclusivamente due categorie di cookie:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong className="text-white">Cookie tecnici / necessari</strong> — indispensabili al corretto funzionamento del sito (
              navigazione, lingua selezionata IT/EN, area riservata admin, gestione del form di contatto). Non richiedono consenso ai sensi
              dell'art. 122 del Codice Privacy.
            </li>
            <li>
              <strong className="text-white">Cookie analitici di terze parti (PostHog)</strong> — utilizzati, previo tuo consenso esplicito,
              per raccogliere informazioni statistiche aggregate e anonime sull'utilizzo del sito al fine di migliorarne le funzionalità. Vengono
              installati solo dopo aver cliccato "Accetta tutti" o averli abilitati dal pannello "Personalizza" del banner.
            </li>
          </ul>

          <h3 className="text-white font-display text-2xl">3. Gestione del consenso</h3>
          <p>
            Al primo accesso compare un banner che consente di:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><span className="text-white">Accetta tutti</span> — abilita tutti i cookie compresi quelli analitici;</li>
            <li><span className="text-white">Rifiuta</span> — mantiene attivi solo i cookie tecnici necessari;</li>
            <li><span className="text-white">Personalizza</span> — consente di scegliere singolarmente le categorie facoltative.</li>
          </ul>
          <p>
            Puoi modificare in qualsiasi momento le tue preferenze cliccando sulla voce <strong className="text-white">"Gestisci cookie"</strong> presente
            nel footer di ogni pagina.
          </p>

          <h3 className="text-white font-display text-2xl">4. Cookie di terze parti</h3>
          <p>
            Le statistiche aggregate sono fornite da <strong className="text-white">PostHog Inc.</strong> e gestite tramite la modalità
            <em> opt-in</em>. Per maggiori informazioni sull'informativa privacy del fornitore: {" "}
            <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="link-gold underline underline-offset-4 text-white">
              posthog.com/privacy
            </a>.
          </p>

          <h3 className="text-white font-display text-2xl">5. Disabilitazione tramite browser</h3>
          <p>È inoltre possibile disabilitare i cookie direttamente dalle impostazioni del browser:</p>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Chrome — Impostazioni → Privacy e sicurezza → Cookie</li>
            <li>Safari — Preferenze → Privacy</li>
            <li>Firefox — Impostazioni → Privacy e sicurezza</li>
            <li>Edge — Impostazioni → Cookie e autorizzazioni sito</li>
          </ul>

          <h3 className="text-white font-display text-2xl">6. Titolare del trattamento</h3>
          <p>
            Scudieri Group S.r.l. — Viale Lunigiana 8, 20125 Milano — P.IVA / CF 09395210967 — email
            scudierigroup@gmail.com — PEC sushicompanysrl1@legalmail.it.
          </p>

          <h3 className="text-white font-display text-2xl">7. Aggiornamenti</h3>
          <p>
            La presente Cookie Policy può essere aggiornata in qualsiasi momento. Verrà data evidenza di eventuali modifiche tramite
            ripresentazione del banner di consenso.
          </p>
        </div>
      </section>
    </div>
  );
}
